<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Consumables for Return</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let consumable of consumableLines">
            <ion-label class="ion-text-wrap">
                <p>{{consumable.description}}</p>
            </ion-label>
            <ion-input type="number" class="ion-text-end" [(ngModel)]="consumable.qty"></ion-input>
            <ion-checkbox slot="start" [(ngModel)]="consumable.isChecked"></ion-checkbox>
        </ion-item>
    </ion-list>
    <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button (click)="saveConsumables()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
